var frozen = {};
var frozenTestMap = new Map();

if (typeof Object.freeze === 'function') {
  Object.freeze(frozen);
}

try {
  frozenTestMap.set(frozen, frozen).delete(frozen);
} catch (_a) {
  var wrap = function wrap(method) {
    return method && function (obj) {
      try {
        frozenTestMap.set(obj, obj).delete(obj);
      } finally {
        return method.call(Object, obj);
      }
    };
  };

  Object.freeze = wrap(Object.freeze);
  Object.seal = wrap(Object.seal);
  Object.preventExtensions = wrap(Object.preventExtensions);
}